import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AnalyticsDescriptionComponent } from './analytics-description.component';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        AnalyticsDescriptionComponent
    ],
    exports: [
        AnalyticsDescriptionComponent
    ]
})
export class AnalyticsDescriptionModule {
}
